/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { listenToCall, doCall, showWebphone } from "../actions/call";
import { callTimer, imgError, toastErrorMsg, logData } from "../utils/utils";
import { set_userInteraction } from "../actions/common.js";
import ringing from "../assets/img/ringing.svg";
import onCall from "../assets/img/onCall.svg";
import noAvatar from "../assets/img/no-avatar.png";
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import OnGoingCall from "./modals/OnGoingCall";

class AgentRowWithService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFilter: "",
      showOnGoingcallModal: false,
      agentProperties: {},
      link_disabled: false,
    };
  }

  componentWillMount() {
    this._ismounted = true;
    if (this.props.user.busy && this.props.user.startTime) {
      this.showTimer(this.props.user.id, this.props.user.startTime, "onCall");
    }
    if (!this.props.serviceDetails.status) {
      this.showTimer(
        this.props.user.id,
        this.props.serviceDetails.status_begin_timestamp,
        `${this.props.serviceDetails.service_id}_unavailable`
      );
    }
    // if(!this.props.user.availability && this.props.user.unavailableTime){
    //   this.showTimer(this.props.user.id, this.props.user.unavailableTime, 'unavailable');
    // }
    if (!this.props.user.busy && this.props.serviceDetails.status) {
      this.showTimer(
        this.props.user.id,
        this.props.serviceDetails.status_begin_timestamp,
        `${this.props.serviceDetails.service_id}_available`
      );
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.user !== this.props.user) {
      const { user: agent } = nextProps;
      if (agent.busy && agent.startTime) {
        this.showTimer(agent.id, agent.startTime, "onCall");
      } else {
        if (!agent.busy && this.state[`timer${agent.id}_onCall`]) {
          clearInterval(this[`timer${agent.id}_onCall`]);
          this.setState(
            {
              [`timer${agent.id}_onCall`]: null,
            },
            () => {
              this[`timer${agent.id}_onCall`] = null;
            }
          );
          // console.log("Call Updated");

          this.onCallDisconnected();
        }
      }

      if (!nextProps.serviceDetails.status && !agent.busy) {
        this.showTimer(
          agent.id,
          nextProps.serviceDetails.status_begin_timestamp,
          `${nextProps.serviceDetails.service_id}_unavailable`
        );
      } else {
        if (
          (agent.busy || nextProps.serviceDetails.status) &&
          this.state[
            `timer${agent.id}_${this.props.serviceDetails.service_id}_unavailable`
          ]
        ) {
          clearInterval(
            this[
              `timer${agent.id}_${this.props.serviceDetails.service_id}_unavailable`
            ]
          );
          this.setState(
            {
              [`timer${agent.id}_${nextProps.serviceDetails.service_id}_unavailable`]:
                null,
            },
            () => {
              this[
                `timer${agent.id}_${nextProps.serviceDetails.service_id}_unavailable`
              ] = null;
            }
          );
        }
      }

      if (nextProps.serviceDetails.status && !agent.busy) {
        this.showTimer(
          agent.id,
          nextProps.serviceDetails.status_begin_timestamp,
          `${nextProps.serviceDetails.service_id}_available`
        );
      } else {
        if (
          (agent.busy || !nextProps.serviceDetails.status) &&
          this.state[
            `timer${agent.id}_${this.props.serviceDetails.service_id}_available`
          ]
        ) {
          clearInterval(
            this[
              `timer${agent.id}_${this.props.serviceDetails.service_id}_available`
            ]
          );
          this.setState(
            {
              [`timer${agent.id}_${nextProps.serviceDetails.service_id}_available`]:
                null,
            },
            () => {
              this[
                `timer${agent.id}_${nextProps.serviceDetails.service_id}_available`
              ] = null;
            }
          );
        }
      }
    }
  };

  componentWillUnmount() {
    this._ismounted = false;
    if (this.state[`timer${this.props.user.id}_onCall`]) {
      clearInterval(this[`timer${this.props.user.id}_onCall`]);
    }
    if (
      this.state[
        `timer${this.props.user.id}_${this.props.serviceDetails.service_id}_unavailable`
      ]
    ) {
      clearInterval(
        this[
          `timer${this.props.user.id}_${this.props.serviceDetails.service_id}_unavailable`
        ]
      );
    }
    if (
      this.state[
        `timer${this.props.user.id}_${this.props.serviceDetails.service_id}_available`
      ]
    ) {
      clearInterval(
        this[
          `timer${this.props.user.id}_${this.props.serviceDetails.service_id}_available`
        ]
      );
    }
  }

  getTelephoneAvailability = (agent, serviceDetails) => {
    let availability = {
      title: "",
      iconColor: "",
    };
    if (agent.busy && agent.didAnswer) {
      availability.title =
        this.props.translations.onCall[this.props.selectedLanguage];
      availability.iconColor = "user-busy";
    }
    if (agent.busy && !agent.didAnswer) {
      if (typeof agent.didAnswer === "undefined") {
        availability.title =
          this.props.translations.onCall[this.props.selectedLanguage];
      } else {
        availability.title =
          agent.type === "outgoing"
            ? this.props.translations.callingTo[this.props.selectedLanguage]
            : this.props.translations.ringingFrom[this.props.selectedLanguage];
        availability.iconColor = "user-busy";
      }
    }
    if (!agent.busy && !serviceDetails.status) {
      availability.title =
        this.props.translations.unavailable[this.props.selectedLanguage];
      availability.iconColor = "user-unavailable";
    }
    if (!agent.busy && !agent.online) {
      availability.title =
        this.props.translations.offline[this.props.selectedLanguage];
      availability.iconColor = "user-offline";
    }
    // if(agent.busy && !serviceDetails.status && agent.service_id!=serviceDetails.service_id){
    // 	availability.title = this.props.translations.unavailable[this.props.selectedLanguage];
    // 	availability.iconColor = 'user-unavailable';
    // }
    if (!agent.busy && serviceDetails.status) {
      availability.title =
        this.props.translations.available[this.props.selectedLanguage];
      availability.iconColor = "user-available";
    }
    // if(agent.busy && serviceDetails.status && agent.service_id!=serviceDetails.service_id){
    // 	availability.title = this.props.translations.available[this.props.selectedLanguage];
    // 	availability.iconColor = 'user-available';
    // }
    return availability;
  };

  // check for user availability. if available then makes call
  // Llamar desde panel de supervisor, vista de agentes por servicios .
  handlePhoneClick = (e) => {
    if (! this.state.link_disabled)
    {
        // console.log('CLICK no more!! AgentRowWithServiceB');
        this.state.link_disabled = true;
        setTimeout(() => { 
            this.state.link_disabled = false; 
            // console.log('CLICK ok!! AgentRowWithService'); 
        }, 5000);
      
        const idArr = e.target.id.split("_");
        const id = idArr[1];
        // const agentsAndSupervisors = [...this.props.agents, ...this.props.supervisors];
        const agentsAndSupervisors = [...this.props.agents];
        const userData = agentsAndSupervisors.find(
          (item) => String(item.id) === id
        );
        const { extension, busy, call_id, didAnswer, online, availability } = userData;
        // debugger
        if (!busy && online && availability) {
          if (extension !== this.props.agentInfo.extension) {
            this.props.showWebphone(true);
            this.makeCall(extension);
          }
        } else {
          if (
            extension !== this.props.agentInfo.extension &&
            busy &&
            (didAnswer || typeof didAnswer === "undefined")
          ) {
            // this.listenToCall(call_id);
            this.userOnCall(userData);
          }
        }
    }
  };

  makeCall = (phoneNumber) => {
    const payload = {
      phoneNumber,
      internalCall: true,
    };
    this.props.doCall(payload);
  };

  userOnCall = (user_Info) => {
    const onCallList = [this.props.agentsOnCallList];
    const userCall = onCallList[0].find(
      (item) => item.callData.agent_id === String(user_Info.id)
    );
    this.setState({
      agentProperties: {
        user_Info: user_Info,
        IVR_name: userCall&&userCall.callData.application_name,
      },
    });
    this.open("showOnGoingcallModal");
  };

  onCallDisconnected = () => {
    if (this.state.showOnGoingcallModal && !this.props.userInteracted) {
      toastErrorMsg(
        this.props.translations.noCall[this.props.selectedLanguage],
        this,
        "callFailedToast"
      );
      this.close("showOnGoingcallModal");
    }
    if (this.props.userInteracted) {
      this.props.set_userInteraction(false);
    }
  };

  listenToCall = (call_id) => {
    const payload = { extension: this.props.agentInfo.extension, call_id };
    this.props.listenToCall(payload).then(
      (res) => {
        if (!res.data.result) {
          toastErrorMsg(
            this.props.translations.callFailed[this.props.selectedLanguage],
            this,
            "callFailedToast"
          );
        }
      },
      (err) => {
        logData(err);
      }
    );
  };

  showTimer = (id, startTime, type) => {
    if (!this[`timer${id}_${type}`] && startTime > 0) {
      const currentTime = moment();
      const startTimeObj = moment(startTime * 1000);
      let sec = currentTime.diff(startTimeObj, "seconds");
      sec = Math.max(0, sec);

      this[`timer${id}_${type}`] = setInterval(() => {
        if (sec < 24 * 3600) {
          sec = moment().diff(startTimeObj, "seconds");
          sec = Math.max(0, sec);
          if (this._ismounted) {
            this.setState({
              [`timer${id}_${type}`]: callTimer(sec),
            });
          }
        } else {
          clearInterval([`timer${id}_${type}`]);
          this.setState({ [`timer${id}_${type}`]: -1 });
        }
      }, 1000);
    }

    if (startTime === 0) {
      this.setState({
        [`timer${id}_${type}`]: "-:-",
      });
    }
  };

  open = (key) => {
    this.setState({ [key]: true });
  };
  close = (key) => {
    // console.log("Close Key Updating");
    this.setState({ [key]: false });
  };

  render() {
    // const onCallWithSameService = user.busy && user.service_id == serviceDetails.service_id;

    const { user, type, serviceDetails, translations, selectedLanguage } =
      this.props;
    const onCallWithSameService = user.busy;

    /* console.log(user); */

    return (
      <div style={{ width: "100%", display: "inline-flex" }}>
        <div
          className={`queueCallRow${this.props.theme}`}
          style={{ width: "40%" }}
        >
          <div className="user-icon pull-left">
            <img
              className={`img-rounded ${user.online ? "" : "img_grayscale"}`}
              src={user.avatar || noAvatar}
              onError={imgError}
              alt={`${user.name} ${user.surname_1}`}
            />
          </div>
          <div
            className="pull-left"
            style={{
              width: "calc(100% - 33px)",
              marginTop: 5,
              wordBreak: "break-all",
            }}
          >
            {user.is_supervisor && (
              <b>
                {user.extension} - {`${user.name} ${user.surname_1}`}
              </b>
            )}
            {!user.is_supervisor && (
              <span>
                {user.extension} - {`${user.name} ${user.surname_1}`}
              </span>
            )}
          </div>
        </div>
        {
          <div
            className={`queueCallRow${this.props.theme} text-left`}
            style={{
              width: !user.online && !onCallWithSameService ? "60%" : "40%",
            }}
          >
            <a
              title={this.getTelephoneAvailability(user, serviceDetails).title}
              id={`${type}_${user.id}`}
              onClick={this.handlePhoneClick}
              style={{
                cursor:
                  (user.busy && !user.didAnswer && typeof user.didAnswer !== "undefined") ||
                  user.extension === this.props.agentInfo.extension ||
                  !user.online 
                  // || (!user.availability && !user.busy)
                    ? "default"
                    : "pointer",
              }}
              className={`btn btn-link btn-lg user-status ${
                this.getTelephoneAvailability(user, serviceDetails).iconColor
              }`}
            >
              {!user.busy && (
                <span id={`${type}_${user.id}`} className="icon icon-phone" />
              )}
              {user.busy &&
                !user.didAnswer &&
                typeof user.didAnswer !== "undefined" && (
                  <img
                    id={`${type}_${user.id}`}
                    src={ringing}
                    height="24"
                    alt=""
                  />
                )}
              {user.busy &&
                (user.didAnswer || typeof user.didAnswer === "undefined") && (
                  <img
                    id={`${type}_${user.id}`}
                    src={onCall}
                    height="24"
                    alt=""
                  />
                )}
            </a>
            {serviceDetails.status && !onCallWithSameService && user.online && (
              <span style={{ fontSize: 11 }}>
                {translations.available[selectedLanguage]}
              </span>
            )}
            {!serviceDetails.status &&
              !onCallWithSameService &&
              user.online && (
                <span style={{ fontSize: 11 }}>
                  {serviceDetails.motive_description ||
                    translations.unavailable[selectedLanguage]}
                </span>
              )}
            {!user.online && !onCallWithSameService && (
              <span style={{ fontSize: 11 }}>
                {translations.offline[selectedLanguage]}
              </span>
            )}
            {onCallWithSameService && user.from && (
              <span>
                <span
                  style={{ fontSize: 11 }}
                  className={`icon ${
                    user.type === "outgoing"
                      ? "icon-arrow-up"
                      : "icon-arrow-down"
                  }`}
                />
                <span style={{ fontSize: 11 }}>
                  <a onClick={() => this.userOnCall(user)}>
                    {user.type === "outgoing" ? user.to : user.from}
                    {user.service_name
                      ? ` (${user.service_name})`
                      : ` (${translations.noService[selectedLanguage]})`}
                  </a>
                </span>
              </span>
            )}
          </div>
        }
        {(user.online || onCallWithSameService) && (
          <div
            className={`queueCallRow${this.props.theme}`}
            style={{
              width: "20%",
              fontSize: 11,
              display: "flex",
              alignItems: "center",
            }}
          >
            {onCallWithSameService && user.startTime && (
              <span style={{ verticalAlign: "middle" }}>
                {this.state[`timer${user.id}_onCall`] !== -1
                  ? this.state[`timer${user.id}_onCall`]
                  : translations.morethan24hr[selectedLanguage]}
              </span>
            )}
            {!serviceDetails.status && !onCallWithSameService && (
              <span style={{ verticalAlign: "middle" }}>
                {this.state[
                  `timer${user.id}_${serviceDetails.service_id}_unavailable`
                ] !== -1
                  ? this.state[
                      `timer${user.id}_${serviceDetails.service_id}_unavailable`
                    ]
                  : translations.morethan24hr[selectedLanguage]}
              </span>
            )}
            {serviceDetails.status && !onCallWithSameService && (
              <span style={{ verticalAlign: "middle" }}>
                {this.state[
                  `timer${user.id}_${serviceDetails.service_id}_available`
                ] !== -1
                  ? this.state[
                      `timer${user.id}_${serviceDetails.service_id}_available`
                    ]
                  : translations.morethan24hr[selectedLanguage]}
              </span>
            )}
            <OnGoingCall
              showOnGoingcallModal={this.state.showOnGoingcallModal}
              handleClose={() => this.close("showOnGoingcallModal")}
              agentProperties={this.state.agentProperties}
            />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userInteracted: state.common.userInteracted,
    agents: state.agentsAndSupervisors.agents,
    agentsOnCallList: state.agentsAndSupervisors.agentsOnCallList,
    supervisors: state.agentsAndSupervisors.supervisors,
    agentInfo: state.agentInfo,
    queuedCalls: state.queuedCalls.queuedCalls,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

const mapDispatchToProps = {
  listenToCall,
  doCall,
  set_userInteraction,
  showWebphone
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentRowWithService);



// WEBPACK FOOTER //
// ./src/agent/AgentRowWithService.js